import React, { useCallback, useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import useSlideIn from "../../hooks/useSlideIn";
import RelativeContainer from "../containers/RelativeContainer";

function LoginPage({ height, width, user: userData }) {
  const { loggingIn, user, signIn } = userData;
  const history = useHistory();
  const [signingIn, setSigningIn] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");

  // Detect mobile based on width
  const isMobile = width < 768;

  // Redirect to home if already logged in
  useEffect(() => {
    if (user && !loggingIn) {
      history.push("/");
    }
  }, [user, loggingIn, history]);

  // const titleSlideIn = useSlideIn({
  //   show: true,
  //   y: -30,
  //   delay: 100,
  //   duration: 400,
  //   opacity: 1,
  // });

  const loginSlideIn = useSlideIn({
    show: true,
    y: 20,
    delay: 300,
    duration: 400,
    opacity: 1,
  });

  const signupSlideIn = useSlideIn({
    show: true,
    y: 20,
    delay: 450,
    duration: 400,
    opacity: 1,
  });

  const handleGoogleLogin = useCallback(() => {
    setSigningIn(true);
    setErrorMessage("");
    signIn(({ error }) => {
      setSigningIn(false);
      if (error) {
        console.error("Login error:", error);
        setErrorMessage(error);
      }
    }, false); // false = not a signup
  }, [signIn]);

  const handleSignUp = useCallback(() => {
    setSigningIn(true);
    setErrorMessage("");
    signIn(({ error }) => {
      setSigningIn(false);
      if (error) {
        console.error("Signup error:", error);
        setErrorMessage(error);
      }
    }, true); // true = this is a signup
  }, [signIn]);

  // Show loading while checking auth state
  if (loggingIn) {
    return (
      <RelativeContainer
        style={{
          height,
          width,
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <div style={{ fontSize: 24, color: "#000" }}>Loading...</div>
      </RelativeContainer>
    );
  }

  return (
    <RelativeContainer
      style={{
        height,
        width,
        justifyContent: "flex-start",
        alignItems: "flex-start",
        background: "#fff",
      }}
    >
      {/* Logo / Title */}
      <div
        style={{
          fontSize: isMobile ? "32px" : "45px",
          backdropFilter: "blur(2px)",
          cursor: "pointer",
          fontWeight: 400,
          color: "#111",
          padding: isMobile ? "18px 20px" : "10px 40px",
          width: isMobile ? "100%" : "auto",
          textAlign: "left",
          boxSizing: "border-box",
          // ...titleSlideIn,
        }}
      >
        moodboard builder
      </div>

      {/* Centered login options */}
      <RelativeContainer
        style={{
          flex: 1,
          width: "100%",
          justifyContent: "center",
          alignItems: "center",
          gap: 24,
          marginBottom: "130px",
        }}
      >
        {errorMessage && (
          <div
            style={{
              fontSize: isMobile ? "16px" : "18px",
              color: "#d32f2f",
              backgroundColor: "#ffebee",
              padding: isMobile ? "12px 16px" : "16px 24px",
              borderRadius: "8px",
              maxWidth: "400px",
              textAlign: "center",
              border: "1px solid #ef5350",
            }}
          >
            {errorMessage}
          </div>
        )}
        <div
          onClick={signingIn ? undefined : handleGoogleLogin}
          style={{
            fontSize: isMobile ? "25px" : "35px",
            backdropFilter: "blur(2px)",

            fontWeight: 500,
            color: "#111",
            cursor: signingIn ? "default" : "pointer",
            opacity: signingIn ? 0.5 : 1,
            transition: "opacity 0.2s",
            ...loginSlideIn,
          }}
        >
          {signingIn ? "signing in..." : "login via google"}
        </div>

        <div
          onClick={signingIn ? undefined : handleSignUp}
          style={{
            fontSize: isMobile ? "25px" : "35px",
            backdropFilter: "blur(2px)",
            fontWeight: 500,
            color: "#111",
            cursor: signingIn ? "default" : "pointer",
            opacity: signingIn ? 0.5 : 1,
            transition: "opacity 0.2s",
            ...signupSlideIn,
          }}
        >
          sign up
        </div>
      </RelativeContainer>
    </RelativeContainer>
  );
}

export default LoginPage;
